import type { PortalConfiguration } from '@axinom/mosaic-core';
import type { PiralPlugin } from 'piral-core';
import type { EnvironmentApi } from './types';

let config: PortalConfiguration;

/**
 * Creates new Pilet API extension retrieving the portal configuration.
 */
export const createEnvironmentApi = (
  portalConfig: PortalConfiguration,
): PiralPlugin<EnvironmentApi> => {
  config = portalConfig;

  return () => ({
    getEnvironment() {
      return config;
    },
  });
};
